import { SolucionPage } from "@/components/SolucionPage";
import { getSolucion } from "@/lib/soluciones";

export default function SeoLocal() {
  const solucion = getSolucion("seo-local")!;
  return <SolucionPage solucion={solucion} />;
}
